import { useState, useRef, useEffect } from 'react';

import closeicon from "../img/close-white.svg";
import Badge from './Badge';

import badgeempty from "../img/badgeempty.svg";

import { translate } from '../functions/translationHelper';
import { deleteAllDownloadedContent } from '../functions/offlineStore';

import getDayMonth from '../functions/getDayMonth';
import Voucher from './Voucher';

function reset() {
  localStorage.clear();
  window.location.reload();
}

function changeRegion() {
  localStorage.removeItem("region");
  window.location.replace("/");
}

async function deleteDownloadedContent(lang) {
  const confirmed = window.confirm(translate("delete_downloaded_content_confirm", lang));

  if (!confirmed) {
    return;
  }

  try {
    await deleteAllDownloadedContent();
    window.location.reload();
  } catch (error) {
    console.error('Downloaded content delete failed:', error);
    window.alert(translate("delete_downloaded_content_error", lang));
  }
}

function ModalBadges(props) {

  const [counter, setCounter] = useState(0);

  useEffect(() => {
    if(counter == 10) {
      if(localStorage.getItem("devmode") == 1) {
        localStorage.removeItem("devmode");
      } else {
        alert("🎉");
        localStorage.setItem("devmode", 1);
      }
      window.location.reload();
    }
  }, [counter])

  return (
    <div className={`modalbadge ${props.open ? null : "modalbadgeclosed"}`} >

      <div className='closebutton' onClick={props.onClose}><img src={closeicon} /></div>

      <div className='badgecollectionsection' style={{ paddingTop: 24, paddingBottom: 40 }}>
        <div className='wrapper' style={{width: 'auto'}}>
          <h2 className='badgecollectionheadline'>{translate("stickers", props.lang)}</h2>

          {
            props.donetrails.length == 0 && <div className='badgecollectionemptystate'><div style={{ display: 'flex', position: 'absolute', top: -20, marginLeft: 24 }}>{props.trails.slice(0, 3).map((obj, index) => <div key={"emptystatebadge-" + index} style={{ zIndex: 4 - index }} className='badgecollectionemptystatebadge'><Badge img={obj.badge} active={true} /></div>)}</div><p>{translate("firststickertext", props.lang)}</p></div>
          }

          <div className='badgecollectionwrapper'>
            {
              props.donetrails.map((obj, index) => (
                <div className='badgecollectionitem' key={"badge-" + index} onClick={() => props.openshare(obj.id)}>
                  <div className='badgepopupanimation' style={{animationDelay: `${400 + index*150}ms`}}><Badge img={obj.badge} active={true} /></div>
                  <p className='badgecollectionitemtitle'>{obj.title}</p>
                  <p className='badgecollectioniteminfotext'>{translate("badgedatetext", props.lang)} {getDayMonth(obj?.donedate)}</p>
                </div>
              ))
            }
            {
              [...Array(props.numberoftrails - props.donetrails.length)].map((obj, index) => (
                <div className='badgecollectionitem' key={"badgeempty-" + index}>
                  <div className='badgecollectionitemempty'><img src={badgeempty} /></div>
                </div>
              ))
            }





          </div>

{props.vouchers?.length > 0 &&
            <div className='vouchersection'>
              <h2>{translate("myrewards", props?.lang)}</h2>
              <div className='voucherlist'>
                {
                  props.vouchers?.map((obj, index) => <Voucher key={"voucher-" + obj?.id} lang={props.lang} alltrails={props?.donetrails?.length}  {...obj} />)
                }
              </div>
            </div>
}

          <div style={{ width: '100%', height: 80, backgroundColor: '#0000' }} onClick={() => setCounter(counter+1)}></div>

          {(process.env.NODE_ENV === 'development' || localStorage.getItem("devmode") == 1) &&
          <div>
            <div style={{ display: 'flex', justifyContent: 'center', marginTop: 240, opacity: 0.6 }} onClick={() => reset()}>Reset progress</div>
            <div style={{ display: 'flex', justifyContent: 'center', marginTop: 12, opacity: 0.6 }} onClick={() => deleteDownloadedContent(props.lang)}>{translate("delete_downloaded_content", props.lang)}</div>
            <div style={{ display: 'flex', justifyContent: 'center', marginTop: 12, opacity: 0.6 }} onClick={() => changeRegion()}>Change region</div>
            {localStorage.getItem("devmode") == 1 && <div style={{ display: 'flex', justifyContent: 'center', marginTop: 12, opacity: 0.6 }} >Dev mode enabled</div>}
            <div style={{ display: 'flex', justifyContent: 'center', marginTop: 12, opacity: 0.6 }} >Version: 0.1.3</div>
          </div>
          }
        </div>
      </div>

    </div>
  );
}

export default ModalBadges;
